import { Options, Vue } from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { Question } from '../question-model';

@Options<Percentile>({})
export default class Percentile extends Vue {

  @Prop()
  private question!: any;

  private fieldValue = 0;

  @Watch('fieldValue')
  private onFieldValueChanged(): void {
    this.question.responses[0].answerNumber = this.fieldValue;
    this.question.responses[0].value = this.fieldValue;
    this.$emit('validForm', this.validForm());
  }

  created(): void {
    // this.fieldValue = this.question.responses[0].answerNumber;
    this.question.responses[0].answerNumber = this.question.responses[0].value ?? 0;
    this.fieldValue = this.question.responses[0].value ?? 0;
  }

  private validForm(): boolean {
    return Number.isInteger(this.question.responses[0].answerNumber);
  }

  // private keyDownFilter(event: any): void {
  //   // Filter out all non-numeric values and negative sign and 'e' and '.'
  //   if (event.keyCode === 69 || event.keyCode === 189 || event.keyCode === 190 || event.keyCode === 110) {
  //     console.log('Invalid key pressed');
  //     event.preventDefault();
  //   }
  // }

}
